/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-04 09:48:00
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-06 09:56:47
 * @FilePath: /dbrank_b/src/routes/cms/components/EditComponent/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import EditBlock from '../EditBlock';
import PropTypes from 'prop-types';

class EditComponent extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    wordList: PropTypes.object,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
  }

  onChange = (type, name, { deep, index }) => {
    const { onChange } = this.props;
    onChange && onChange(type, name, { deep, index });
  }

  onSave = (deep) => {
    const { onSave } = this.props;

    onSave && onSave(deep);
  }

  render() {
    const { isEdit, wordList } = this.props;

    return (
      <div className={s.container}>
        {(wordList || []).map((item, index) => (
          <EditBlock
            key={`${index}_${item.label}`}
            isEdit={isEdit}
            title={item.label}
            content={item.value}
            onChange={(type, name, i) => {
              this.onChange(type, name, { deep: index, index: i})
            }}
            onSave={() => {
              this.onSave(index);
            }}
          />
        ))}
      </div>
    )
  }
}

export default withStyles(s)(EditComponent)



// WEBPACK FOOTER //
// src/routes/cms/components/EditComponent/index.js